import { NonSerializedInventoryDataSourceResponse } from 'src/app/proto/generated/inv_non_serialized_inventory_service_pb';
import { NonSerializedInventoryModel } from './non-serialized-inventory.model';

export class NonSerializedInventoryDataSourceModel {
  data: NonSerializedInventoryModel[] = [];
  total = 0;

  static Mapper(
    source: NonSerializedInventoryDataSourceResponse
  ): NonSerializedInventoryDataSourceModel {
    const destination = new NonSerializedInventoryDataSourceModel();
    destination.data = NonSerializedInventoryModel.MapperList(source.getDataList());
    destination.total = source.getTotal();
    return destination;
  }
}
